export const getSSRMode = () => typeof window === 'undefined'; // true if server side rendering

export function isRSC(reactImport: typeof import('react')): boolean {
  return 'createContext' in reactImport;
}
